import { Card, CardBody, CardFooter, CardHeader } from '@heroui/react';
import React from 'react';
import StartBookingButton from './start-booking-button';

interface PriceBreakdownLayoutProps {
  header: React.ReactNode;
  children: React.ReactNode;
}

export default function PriceBreakdownLayout({
  header,
  children,
}: PriceBreakdownLayoutProps) {
  return (
    <Card className="rounded-none" data-testid="breakdownCard">
      <CardHeader className="w-full text-[var(--color-text-inverse)] bg-[var(--color-highlight-brand)] rounded-none p-4">
        {header}
      </CardHeader>
      <CardBody className="bg-[var(--color-background-secondary)] px-4 pb-6">
        {children}
      </CardBody>
      <CardFooter className="p-6">
        <StartBookingButton
          className="w-full"
          testId="priceBreakdownBookingButton"
        />
      </CardFooter>
    </Card>
  );
}
